import {publicRequestData, publicRevokePermission} from "./apiPublic";

export const PUBLIC_DATA_REQUEST = "PUBLIC_DATA_REQUEST"
export const PUBLIC_DATA_OK = "PUBLIC_DATA_OK"
export const PUBLIC_DATA_ERROR = "PUBLIC_DATA_ERROR"

export const PUBLIC_REVOKE_REQUEST = "PUBLIC_REVOKE_REQUEST"
export const PUBLIC_REVOKE_OK = "PUBLIC_REVOKE_OK"
export const PUBLIC_REVOKE_ERROR = "PUBLIC_REVOKE_ERROR"

export function requestData(token) {
    return function (dispatch) {
        if (!token) {
            dispatch(dataRequestedError())
            return Promise.reject()
        }

        dispatch(dataRequested())

        const request = {
            token,
        }

        publicRequestData(request)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(response => dispatch(dataRequestedOk(response)))
            .catch(() => dispatch(dataRequestedError()))
    }
}

export function dataRequested() {
    return {
        type: PUBLIC_DATA_REQUEST,
    }
}

function dataRequestedOk(response) {
    return {
        type: PUBLIC_DATA_OK,
        sharedData: response,
    }
}

function dataRequestedError() {
    return {
        type: PUBLIC_DATA_ERROR,
    }
}

export function revokePermission(token) {
    return function (dispatch) {
        if (!token) {
            return Promise.reject()
        }

        const request = {
            token
        }

        dispatch(revokePermissionSended())

        publicRevokePermission(request)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(response => dispatch(revokePermissionOk(response)))
            .catch(() => dispatch(revokePermissionError()))
    }
}

export function revokePermissionSended() {
    return {
        type: PUBLIC_REVOKE_REQUEST
    }
}

function revokePermissionOk(response) {
    return {
        type: PUBLIC_REVOKE_OK,
        revokeReponse: response,
    }
}

function revokePermissionError() {
    return {
        type: PUBLIC_REVOKE_ERROR
    }
}
